// extracted by mini-css-extract-plugin
export default {"wrapper":"VO-z","availablePromoMessagesLabel":"WO-z","promoMessageList":"XO-z","promoMessage":"YO-z","appliedPromoMessage":"ZO-z","promoMessageAmount":"_O-z"};